import AutoPayTag from "@/components/AutoPayTag";

interface InvoiceAccountNameProps {
  name: string;
  isAutoPayOn: boolean;
  hasDefaultPaymentMethod: boolean;
}

function InvoiceAccountName({
  name,
  isAutoPayOn,
  hasDefaultPaymentMethod,
}: InvoiceAccountNameProps) {
  return (
    <div className="flex flex-row items-center font-hanken font-semibold pb-3">
      {name}
      <AutoPayTag
        isAutoPayOn={isAutoPayOn}
        hasDefaultPaymentMethod={hasDefaultPaymentMethod}
        className="ml-2"
      />
    </div>
  );
}

export default InvoiceAccountName;
